// eslint-disable-next-line require-jsdoc
import React from 'react';

// eslint-disable-next-line require-jsdoc
export const CheckFacts = () => {
  return (
    <div className="footer-main-section">
      <div className="container-center-lg">
        <div className="footer-section">
          <div className="row">
            <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
              <div style={{ padding: '10px' }}>
                <h4 style={{ color: '#505050' }}>Check Facts:</h4>
                <h4>Blank vs. Restrictive Endorsements</h4>
              </div>
            </div>
            <div className="col-lg-8 col-md-8 col-sm-6 col-xs-12">
              <p className="p2-regular" style={{ padding: '10px', paddingTop: '15px' }}>
                The person who wrote and signed the front of the check is called the remitter. The
                person who is paid with the check is called the payee. When a payee writes or stamps
                "For Deposit Only" on the back of the check, it is called a restrictive endorsement
                because it limits what can be done with the check.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
